<template>
  <div v-bem>
    <div v-bem:inner>
      <button v-bem:backButton @click="closeWidget">
        <template v-if="$screen.lg">
          <Icon name="close" />
        </template>
        <template v-else>
          <Icon v-bem:backIcon name="arrow-left" />{{ 'Zurück' }}
        </template>
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Icon from './Icon.vue';

export default {
  name: 'ClosableOverlay',
  components: { Icon },
  methods: {
    ...mapActions('pageHeader', ['closeWidget']),
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.closable-overlay {
  position: fixed;
  z-index: 2;
  inset: utils.f-rem-calc(60) 0 0 0;
  padding: utils.f-rem-calc(24) utils.f-rem-calc(16);
  background-color: map.get(utils.$v-colors, acc-gray-020);

  @include utils.bs-media-breakpoint-up(lg) {
    inset: utils.f-rem-calc(84) 0 auto 0;
    padding: utils.f-rem-calc(44);
  }

  @at-root #{&}__inner {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @at-root #{&}__back-button {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    border: none;
    background-color: transparent;

    @include utils.bs-media-breakpoint-up(lg) {
    }

    &:focus {
      outline: none;
    }
  }

  @at-root #{&}__back-icon {
    margin-right: utils.f-rem-calc(8);
    color: map.get(utils.$v-colors, acc-orange);
  }
}
</style>
